import Header from "../Header";

const Navigation = () => {
  return (
    <div>
        <Header />
    </div>
  )
}

export default Navigation